// SPEC-52 · the words of « Idioma da atleta » on her profile. PT first
// (BRAND.md), FR and EN key for key. The segments read PT · FR · EN in
// every language, each language named in its own (copy.languages).

import type { Words } from "../shell";

export const athleteLanguagePt = {
  label: "Idioma da atleta",
  failed: "Não consegui guardar o idioma da atleta. Tenta outra vez.",
} as const;

export const athleteLanguageFr: Words<typeof athleteLanguagePt> = {
  label: "Langue de l’athlète",
  failed: "Je n’ai pas pu enregistrer la langue de l’athlète. Réessaie.",
};

export const athleteLanguageEn: Words<typeof athleteLanguagePt> = {
  label: "Athlete’s language",
  failed: "I couldn’t save the athlete’s language. Try again.",
};
